/**
 * Utility for transferring chat state between landing page and main app
 * Uses localStorage to avoid URL param issues
 */
import { persistence } from '../services/persistence';

export interface ChatStateTransfer {
  history: Array<{
    content: string;
    sender: 'user' | 'assistant';
    timestamp: string;
  }>;
  message?: string;
  timestamp: number; // When the transfer was created
}

const STORAGE_KEY = 'eir-chat-state-transfer';
const MAX_AGE_MS = 5 * 60 * 1000; // 5 minutes

export const saveChatStateTransfer = (state: Omit<ChatStateTransfer, 'timestamp'>): void => {
  const transfer: ChatStateTransfer = {
    ...state,
    timestamp: Date.now(),
  };
  persistence.setJSON(STORAGE_KEY, transfer);
};

export const loadChatStateTransfer = (): ChatStateTransfer | null => {
  const transfer = persistence.getJSON<ChatStateTransfer | null>(STORAGE_KEY, null);
  if (!transfer) return null;

  const age = Date.now() - transfer.timestamp;
  if (age > MAX_AGE_MS) {
    clearChatStateTransfer();
    return null;
  }

  return transfer;
};

export const clearChatStateTransfer = (): void => {
  persistence.removeItem(STORAGE_KEY);
};

